import { useCallback } from 'react';
import { useQueryClient } from 'react-query';

export const useClearQueryCache = () => {
  const queryClient = useQueryClient();

  return useCallback((queryKey: string) => queryClient.removeQueries({ queryKey, stale: false }), [queryClient]);
};
